export default "__VITE_ASSET__BDEIDe8S__"